<template>
  <div
    class="custom-splashscreen"
    v-if="this.isVisible">

    <img :src="src"/>
  </div>
</template>

<script>
export default {
  name: 'CustomSplashscreen',
  props: ['timeout', 'src'],
  data: function () {
    return {
      isVisible: true,
      handler: null
    }
  },
  mounted () {
    if (this.timeout === 0) {
      this.isVisible = false
      console.info('CustomSplashScreen: no countdown')
      this.$emit('splashscreen-complete')
      return
    }
    console.info(`CustomSplashScreen: countdown started ${this.timeout}`)
    this.handler = setTimeout(() => {
      this.isVisible = false
      console.info('CustomSplashScreen: countdown finished')
      this.$emit('splashscreen-complete')
      clearTimeout(this.handler)
    }, parseInt(this.timeout))
  },
  beforeDestroy () {
    console.info('CustomSplashScreen: beforeDestroy')
    clearTimeout(this.handler)
  }
}
</script>
